<script>
  import { createEventDispatcher } from 'svelte';
  let highlight = false;
  const dispatch = createEventDispatcher();
</script>

<style src="./highlights.scss">
</style>

<div class="highlights">
  <span>Høydepunkter</span>
  <label class="switch">
    <input
      type="checkbox"
      bind:checked={highlight}
      on:change={() => dispatch('highlight', highlight)} />
    <span class="slider round" />
  </label>
</div>
